var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ReviewsTeaserModuleUi"},[_c('ReviewsTeaser',_vm._b({},'ReviewsTeaser',Object.assign({}, _vm.content),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }